// Central place for site-wide brand data used across pages.
export const BRAND = {
  name: "Vikramshila",
  fullName: "Vikramshila Classes",
  tagline: "Shaping Futures. Building Excellence.",
  email: "enquiry@vikramshilaclasses.com",
  phonePrimary: "+91 79709 22241",
  phoneSecondary: "+91 6123 422559",
  whatsapp: "917970922241",
  address: "Rajeev Nagar, Junction On Road, No. 23 & 24, Patna – 800024",
  domain: "www.vikramshilaclasses.com",
  instagram: "https://www.instagram.com/vikramshilaclasses/",
  instagramHandle: "vikramshilaclasses",
};

export const waLink = (msg = "Hi, I'd like to book a free demo class at Vikramshila Classes.") =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(msg)}`;

export const telLink = `tel:+${BRAND.whatsapp}`;

export const IMG = {
  heroStudents: "https://images.pexels.com/photos/3231359/pexels-photo-3231359.jpeg",
  studentsGroup: "https://images.pexels.com/photos/3231358/pexels-photo-3231358.jpeg",
  classroom: "https://images.unsplash.com/photo-1551731409-43eb3e517a1a?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
  teacher: "https://images.pexels.com/photos/36781271/pexels-photo-36781271.jpeg",
  studyMaterials: "https://images.unsplash.com/photo-1628258334105-2a0b3d6efee1?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  studentMale: "https://images.unsplash.com/photo-1680525021501-ddea41969892?crop=entropy&cs=srgb&fm=jpg&w=400&q=80",
  studentFemale: "https://images.unsplash.com/photo-1749700332031-cf99864959ea?crop=entropy&cs=srgb&fm=jpg&w=400&q=80",
};
